import {Component, forwardRef, Input, OnInit} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {BrowseConfig} from "@core/bean/browse-config";
import {BrowseService} from "@shared/components/browse/browse.service";
export const EXE_COUNTER_VALUE_ACCESSOR:any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => QuickSearchComponent),
  multi: true
};
@Component({
  selector: 'app-quick-search',
  templateUrl: './quick-search.component.html',
  styles: [],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class QuickSearchComponent implements OnInit, ControlValueAccessor {
  randomUserUrl = 'api/supplier/quick-search';
  searchChange$ = new BehaviorSubject('');
  optionList = [];
  isLoading = false;

  onSearch(value: string): void {
    this.isLoading = true;
    this.searchChange$.next(value);
  }

  constructor(private http: HttpClient,private browseService:BrowseService) {
  }

  ngOnInit(): void {
    // tslint:disable-next-line:no-any
    const getRandomNameList = (str: string) =>
      this.http.get(`${this.randomUserUrl + '?maxResult=5&&searchValue=' + str}`).pipe(map((res: any) => res)).pipe(map((list: any) => {
      return list;
    }));
    const optionList$: Observable<string[]> = this.searchChange$.asObservable().pipe(debounceTime(500)).pipe(switchMap(getRandomNameList));
    optionList$.subscribe(data => {
      this.optionList = data;
      this.isLoading = false;
    });
  }

  @Input() name:string;

  /**
   * 是否必填
   */
  @Input() required:boolean;
  /**
   * 是否禁用
   */
  @Input() disabled:boolean;

  //字段名
  @Input() fieldName:string = 'id';

  innerValue:any;
  propagateChange = (_:any) => {
  };
  writeValue(obj:any):void {
    this.innerValue = obj;
  }
  registerOnChange(fn:any):void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn:any):void {
  }
  changeVal(val) {
    this.propagateChange(val);
  }

  //供应商浏览按钮
  //供应商浏览按钮
  supplierConFig: BrowseConfig = new BrowseConfig('SupplierBrowseComponent');
  selectSupplier(){
    this.browseService.open(this.supplierConFig,
      (result) => {
        if(this.optionList && this.optionList.length > 0){
          for(let i=0;i<this.optionList.length;i++){
            if(result.id == this.optionList[i].id){
              this.innerValue = this.optionList[i][this.fieldName];
              this.propagateChange(this.innerValue);
              return;
            }
          }
          let supplier = {
            englishName: result.englishName,
            id: result.id,
            logogram: result.logogram,
            shortName: result.shortName,
            supplierCode: result.supplierCode,
            supplierName: result.supplierName,
          };
          this.optionList.push(supplier);
          this.innerValue = supplier[this.fieldName];
          this.propagateChange(this.innerValue);
        }else{
          let supplier = {
            englishName: result.englishName,
            id: result.id,
            logogram: result.logogram,
            shortName: result.shortName,
            supplierCode: result.supplierCode,
            supplierName: result.supplierName,
          };
          this.optionList.push(supplier);
          this.innerValue = supplier[this.fieldName];
          this.propagateChange(this.innerValue);
        }
      },
      () => {
      });
  }
}
